import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { IoMdClose } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import QuantitySelector from "../components/QuantitySelector";
import {
  increaseQuantity,
  decreaseQuantity,
  removeFromCart,
} from "../redux/store/cartSlice";
import NewsTicker from "../components/Home/Newtricker";
import Faqs from "../components/Home/Faqs";

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);

  const handleCheckout = () => {
    navigate("/checkout");
  };

  const subtotalPrice = cartItems.reduce(
    (acc, item) =>
      acc + Number(item.unitPrice || item.variants?.[0]?.price || 0) * item.quantity,
    0,
  );
  const delivery = 7.95;
  const total = subtotalPrice + delivery;

  return (
    <>
      <Navbar />
      <div className="bg-white w-full py-[1rem] mb-[2rem] px-[1rem] sm:px-[5rem] text-[16px] text-gray-500">
        <span className="text-gray-800">
          {" "}
          <Link to={"/"}>Home</Link>
        </span>{" "}
        {">"} Cart
      </div>
      <div className="py-6 px-4 md:px-16 lg:px-24 bg-white min-h-screen">
        {/* Title */}
        <div className="flex justify-center py-8">
          <h1 className="font-syne text-3xl md:text-5xl font-bold">Cart</h1>
        </div>

        {/* Main Section */}
        {cartItems && cartItems.length ? (
          <div className="flex flex-col md:flex-row items-stretch gap-10">
            {/* ================= LEFT SIDE - CART ITEMS ================= */}
            <div className="w-full md:w-2/3 flex flex-col gap-4">
              {/* Desktop Table */}
              <div className="hidden md:block overflow-hidden rounded-xl">
                <table className="w-full border-separate border-spacing-y-4">
                  <thead>
                    <tr className="text-left text-gray-600 text-sm shadow-md uppercase tracking-wider">
                      <th className="px-6 py-3 w-[40%]">Products Detail</th>
                      <th className="px-6 py-3 w-[15%] text-center">
                        Quantity
                      </th>
                      <th className="px-6 py-3 w-[15%]">Price</th>
                      <th className="px-6 py-3 w-[15%]">Total</th>
                      <th className="px-6 py-3 w-[5%]"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {cartItems.map((item) => (
                      <tr
                        key={item.cartKey || item.id}
                        className="bg-white shadow-md transition-all duration-300 rounded-xl"
                      >
                        <td className="px-6 py-5">
                          <div className="flex items-center gap-4">
                            <img
                              src={item.image}
                              alt={item.title}
                              className="w-16 h-16 object-cover rounded-lg"
                            />
                            <div>
                              <h1 className="font-semibold text-gray-800">
                                {item.title}
                              </h1>
                              <p className="text-sm text-gray-500">
                                {item.vendor}
                              </p>
                              {item.variantTitle && (
                                <p className="text-xs text-gray-500">
                                  {item.variantTitle}
                                </p>
                              )}
                            </div>
                          </div>
                        </td>

                        <td className="px-6 py-5 text-center font-medium">
                          <QuantitySelector
                            value={item.quantity}
                            max={
                              item.selectedVariant?.inventory_quantity ||
                              item.variants?.[0]?.inventory_quantity ||
                              99
                            }
                            min={1}
                            onChange={(newQty) => {
                              if (newQty > item.quantity)
                                dispatch(increaseQuantity(item.cartKey || item.id));
                              else if (newQty < item.quantity)
                                dispatch(decreaseQuantity(item.cartKey || item.id));
                            }}
                          />
                        </td>

                        <td className="px-6 py-5 font-medium text-gray-700">
                          ${Number(item.unitPrice || item.variants?.[0]?.price || 0)}
                        </td>

                        <td className="px-6 py-5 font-semibold text-gray-900">
                          $
                          {(
                            Number(item.unitPrice || item.variants?.[0]?.price || 0) *
                            item.quantity
                          ).toFixed(2)}
                        </td>

                        <td className="px-6 py-5 text-center">
                          <button
                            onClick={() =>
                              dispatch(removeFromCart(item.cartKey || item.id))
                            }
                            className="transition-all duration-300 hover:scale-110"
                          >
                            <IoMdClose className="text-red-500 text-xl hover:text-red-700" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Link
                  to={"/fragrance"}
                  className="text-[18px] underline text-red-500"
                >
                  Continue Shopping
                </Link>

                <Faqs />
              </div>

              {/* Mobile Cards */}
              <div className="md:hidden flex flex-col gap-4">
                {cartItems.map((item) => (
                  <div
                    key={item.cartKey || item.id}
                    className="bg-white p-4 rounded-xl shadow-md flex flex-col gap-4"
                  >
                    <div className="flex items-center gap-4">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-24 h-24 object-cover rounded-lg"
                      />
                      <div>
                        <h1 className="font-semibold text-gray-800">
                          {item.title}
                        </h1>
                        <p className="text-sm text-gray-500">{item.vendor}</p>
                        {item.variantTitle && (
                          <p className="text-xs text-gray-500">
                            {item.variantTitle}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="flex justify-between items-center">
                      <QuantitySelector
                        value={item.quantity}
                        max={
                          item.selectedVariant?.inventory_quantity ||
                          item.variants?.[0]?.inventory_quantity ||
                          99
                        }
                        min={1}
                        onChange={(newQty) => {
                          if (newQty > item.quantity)
                            dispatch(increaseQuantity(item.cartKey || item.id));
                          else if (newQty < item.quantity)
                            dispatch(decreaseQuantity(item.cartKey || item.id));
                        }}
                      />
                      <div className="text-gray-700 font-medium">
                        ${Number(item.unitPrice || item.variants?.[0]?.price || 0)}
                      </div>
                      <div className="font-semibold text-gray-900">
                        $
                        {(
                          Number(item.unitPrice || item.variants?.[0]?.price || 0) *
                          item.quantity
                        ).toFixed(2)}
                      </div>
                      <button
                        onClick={() =>
                          dispatch(removeFromCart(item.cartKey || item.id))
                        }
                        className="transition-all duration-300 hover:scale-110"
                      >
                        <IoMdClose className="text-red-500 text-xl hover:text-red-700" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ================= RIGHT SIDE - ORDER SUMMARY ================= */}
            <div className="w-full md:w-1/3">
              <div className="bg-white p-8 rounded-2xl sticky top-10 h-fit shadow-md">
                <h2 className="text-xl font-semibold mb-6">Order Summary</h2>
                <div className="space-y-4">
                  <div className="flex justify-between">
                    <p>Sub-Total</p>
                    <span>${subtotalPrice.toFixed(2)}</span>
                  </div>

                  <div className="flex justify-between">
                    <p>Delivery</p>
                    <span>${delivery.toFixed(2)}</span>
                  </div>

                  <hr />

                  <div className="flex justify-between font-semibold text-lg">
                    <p>Total</p>
                    <span>${total.toFixed(2)}</span>
                  </div>

                  <button
                    onClick={handleCheckout}
                    className="w-full bg-gray-500 text-white py-4 mt-6 rounded-lg
                             transition-all duration-300 ease-in-out
                             hover:bg-gray-700 hover:shadow-lg hover:-translate-y-1
                             active:scale-95"
                  >
                    Process Order
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex justify-center items-center h-[30vh]">
            <p className="text-gray-500 text-[18px]">No Product in Cart</p>
          </div>
        )}
      </div>
      <NewsTicker />
      <Footer />
    </>
  );
};

export default Cart;
